import styled from 'styled-components';

export const Container = styled.div({
  marginLeft: '20rem',
});

export const Title = styled.p(({ theme }) => ({
  fontSize: theme.typography.size16,
  color: theme.palette.erieBlack,
}));
